import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Placeholder, Header, Button, Divider, Icon, Dimmer, Loader
} from 'semantic-ui-react';

import moment from 'moment';

// redux
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';

import CancelSubscriptionModal from './cancelSubscriptionModal';

import { getNextSubscriptionPayment } from '../../../modules/subscription';
import { getUserProfile } from '../../../modules/user';

import currencyUtil from '../../../utils/currencyUtil';
import { withHostAppProxy } from '../../../contexts/HostAppProxyContext';
import { toast } from 'react-toastify';
import './subscription.css';

export class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.nativeRefreshTimers = [];
  }

  componentDidMount() {
    const { userProfile, hostAppProxy } = this.props;
    const subscription = userProfile.account.subscription;
    if (!hostAppProxy.settings.isWrapped && subscription?.provider !== 'APPLE' && subscription?.pricingPlan?.externalId) {
      this.getNextPayment(userProfile.account.subscription._id);
    }
  }

  componentDidUpdate(prevProps) {
    const previousEvent = prevProps.hostAppProxy?.settings?.nativePurchaseEvent;
    const event = this.props.hostAppProxy?.settings?.nativePurchaseEvent;
    if (!event || event === previousEvent) return;
    if (event.data?.status === 'success') {
      toast.success(
        event.data?.operation === 'restore'
          ? this.props.t('PurchasesRestored', 'Purchases restored.')
          : this.props.t('PurchaseSuccessful', 'Purchase successful.')
      );
      [500, 2000, 5000].forEach(delay => {
        this.nativeRefreshTimers.push(
          setTimeout(
            () => this.props.getUserProfile(this.props.idToken),
            delay
          )
        );
      });
    } else if (event.data?.status === 'cancelled') {
      toast.info(this.props.t('Cancelled'));
    } else if (event.data?.status === 'error') {
      toast.error(
        this.props.t(
          'PurchaseFailed',
          'The purchase could not be completed.'
        )
      );
    }
  }

  componentWillUnmount() {
    this.nativeRefreshTimers.forEach(timer => clearTimeout(timer));
  }

  getNextPayment = async (subscriptionId) => {
    const { idToken } = this.props;
    this.props.getNextSubscriptionPayment(idToken, subscriptionId);
  }

  changePaymentInfo = () => {
    const { userProfile } = this.props;
    if (userProfile && userProfile.account.subscription && userProfile.account.subscription.updateUrl) {
      this.setState({
        loadingPaddleCheckout: true
      }, () => {
        window.Paddle.Checkout.open({
          override: userProfile.account.subscription.updateUrl,
          loadCallback: this.loadedPaddleCheckout
        });
      });
    }
  }

  loadedPaddleCheckout = () => {
    this.setState({
      loadingPaddleCheckout: false
    });
  }

  upgradeSubscription = () => {
    const { changePage } = this.props;
    changePage('/products');
  }

  showCancelModal = (show) => {
    this.setState({
      showCancelModal: show
    });
  }

  render() {
    const { loadingPaddleCheckout } = this.state;
    const { userProfile, nextPayment, t } = this.props;
    if (!userProfile || !userProfile.account.subscription) {
      return (
        <Placeholder>
          <Placeholder.Header image>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Header>
          <Placeholder.Paragraph>
            <Placeholder.Line length='medium' />
            <Placeholder.Line length='short' />
          </Placeholder.Paragraph>
        </Placeholder>
      );
    }
    const { subscription } = userProfile.account;
    const { showCancelModal } = this.state;
    const hostSettings = this.props.hostAppProxy?.settings || {};
    const isNative = Boolean(hostSettings.isWrapped);
    const isPaid =
      subscription.pricingPlan?.product?.internalId !== 'free';
    const isAppleManaged = subscription.provider === 'APPLE';

    return (
      <div>
        {!isNative && <CancelSubscriptionModal open={showCancelModal} onClose={() => this.showCancelModal(false)} />}
        {
          subscription.status !== 'deleted' && (
            <div>
              <Header as='h4'>
                { subscription.pricingPlan && t(subscription.pricingPlan.product.title) }
                { !isNative && !isAppleManaged && subscription.pricingPlan && subscription.pricingPlan.product.internalId !== 'free'
                && (
                  [
                    <Button
                      key='cancelSubscriptionButton'
                      compact
                      floated='right'
                      basic
                      negative
                      content={t('Cancel')}
                      onClick={() => this.showCancelModal(true)}
                    />,
                    <Header.Subheader key='cancelSubscriptionHeader'>
                      {
                        nextPayment && (
                          <div>
                            {`${t('NextPayment')}: ${nextPayment.amount}${currencyUtil.getSymbol(nextPayment.currency)} (${moment(nextPayment.payout_date).format('L')})` }
                            {
                              subscription.status === 'past_due'
                              && (
                                <div style={{ color: 'red' }}>
                                  <br />
                                  {t('PaymentPastDueMessage', { nextAttempt: new Date(subscription.nextRetryDate).toLocaleDateString() })}
                                </div>
                              )
                            }
                          </div>
                        )
                      }
                    </Header.Subheader>
                  ])
                }
              </Header>
              <Divider fitted />
              { !isNative && !isAppleManaged && subscription.pricingPlan && subscription.pricingPlan.product.internalId !== 'free'
              && (
                [
                  <Header as='h4' key='change-payment-information-header'>
                    {t('ChangePaymentInformation')}
                    <Button key='change-payment-information-button' compact floated='right' basic color='grey' content={t('Update')} onClick={this.changePaymentInfo} />
                    <Header.Subheader key='change-payment-information-subheader'>
                      <Icon name='credit card outline' />
                      <Icon name='cc paypal' style={{ color: '#3b7bbf' }} />
                    </Header.Subheader>
                  </Header>,
                  <Divider key='change-payment-information-divider' fitted />
                ]
              )
            }
            </div>
          )
        }
        {isNative && hostSettings.purchaseMode === 'ios_iap' && (
          <React.Fragment>
            <div className='subscription-action-row subscription-action-row--native'>
              <div className='subscription-action-copy'>
                <Header as='h4'>
                  {t('AppStorePurchases', 'App Store purchases')}
                  {subscription.provider === 'PADDLE' && isPaid && (
                    <Header.Subheader>
                      {t(
                        'ManageWebSubscription',
                        'Your existing web subscription remains active. Manage it on betareader.io.'
                      )}
                    </Header.Subheader>
                  )}
                </Header>
              </div>
              <div className='subscription-actions'>
                <Button
                  compact
                  basic
                  content={t('RestorePurchases', 'Restore purchases')}
                  onClick={this.props.hostAppProxy.restorePurchases}
                />
                <Button
                  compact
                  basic
                  content={t('ManageSubscription', 'Manage subscription')}
                  onClick={this.props.hostAppProxy.manageSubscriptions}
                />
              </div>
            </div>
            <Divider fitted className='subscription-action-divider' />
          </React.Fragment>
        )}
        {!isNative && isAppleManaged && isPaid && (
          <React.Fragment>
            <div className='subscription-action-row subscription-action-row--apple-web'>
              <div className='subscription-action-copy'>
                <Header as='h4'>
                  {t('AppStorePurchases', 'App Store purchases')}
                </Header>
              </div>
              <div className='subscription-actions'>
                <Button
                  as='a'
                  href='https://apps.apple.com/account/subscriptions'
                  target='_blank'
                  rel='noopener noreferrer'
                  compact
                  basic
                  content={t('ManageSubscription', 'Manage subscription')}
                />
              </div>
            </div>
            <Divider fitted className='subscription-action-divider' />
          </React.Fragment>
        )}
        {
          subscription.status === 'deleted'
          && (
            <Header as='h4'>
              { subscription.pricingPlan && t(subscription.pricingPlan.product.title) }
              <Header.Subheader>
                {t('YourSubscriptionHasBeenCancelled')}
                <br />
                {t('ValidUntil')}
                {' '}
                {moment(subscription.validUntilDate).format('L')}
              </Header.Subheader>
            </Header>
          )
        }
        <div className='subscription-action-row subscription-action-row--upgrade'>
          <div className='subscription-action-copy'>
            <Header as='h4'>
              {t('UpgradeSubscriptionTitle')}
              <Header.Subheader>
                {t('UpgradeSubscriptionPromoText')}
              </Header.Subheader>
            </Header>
          </div>
          <div className='subscription-actions'>
            <Button
              compact
              basic
              positive
              content={t('Subscriptions')}
              onClick={this.upgradeSubscription}
            />
          </div>
        </div>
        {
          loadingPaddleCheckout && (
            <Dimmer active inverted page>
              <Loader>{t('Loading')}</Loader>
            </Dimmer>
          )
        }
      </div>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  nextPayment: state.subscription.nextPayment
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getNextSubscriptionPayment,
  getUserProfile,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(
  withHostAppProxy(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(Subscription))
  )
);
